import { render } from "./GenericBanner.vue?vue&type=template&id=b928b6a0&scoped=true&ts=true"
import script from "./GenericBanner.vue?vue&type=script&lang=ts"
export * from "./GenericBanner.vue?vue&type=script&lang=ts"

import "./GenericBanner.vue?vue&type=style&index=0&id=b928b6a0&lang=scss&scoped=true"

import exportComponent from "E:\\agent\\azdo\\CI\\a1-CI\\_work\\151\\s\\src\\MagnetoEnergy.Vue.WebClient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b928b6a0"]])

export default __exports__